import React, { useState, useEffect } from 'react';
import { MainHeader } from '.';
import { useParams } from 'react-router-dom';
import getAds from '../../../ApiV2/getAds.jsx';


let SponsorsPage = () => {
  const { location } = useParams();
  const [listOfAds, setListOfAds] = useState([]);


  useEffect(() => {
    console.log(location)
    if (location !== undefined) {
      getAds(location)
        .then(response => {
          response.json().then(data => ({
            data: data,
            status: response.status
          }))
            .then(jsonResponse => {

              setListOfAds(jsonResponse.data);
              console.log(jsonResponse.data)
            })
        })
        .catch((error) => {
          console.log(error);
        })
    }
  }, [])

  const displayListOfAds = () => {
    return (
      <div className="space-on-bottom">
        <div className="menu-background-section">
          <h5>Thank You to Our Sponsors</h5>
          <p>This digital menu is made possible through the generous support of our sponsors.</p>
          <p>Please take a moment to view their ads, learn more about their businesses, and support the companies that help enhance your experience here. Their partnership allows us to provide this convenient digital menu at no cost to you.</p>
          <p>When possible, please support the sponsors featured on this page by visiting, contacting, or doing business with them.</p>
        </div>
          {


            listOfAds.map((adItem) => {
              return (

                <div className="menu-background-section">
                  {/* <img src={adItem.sponsorImagePath} className="responsive-image" /> */}
                  <img src={adItem.adImagePath} className="responsive-image" />
                </div>
              )
            })

          }
      </div>
    )
  }

  return (
    <>
      <MainHeader />

      {displayListOfAds()}

    </>
  );
}

export default SponsorsPage;